import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import FooterOne from "../../../layout/footers/footer-one";
import ThreeColumns from "./three-columns";

const PortfolioThreeColumns = () => {
    return (
        <>
            <SEO pageTitle="Standard Grid | Arclight Developers" />
            <HeaderTwo />
            <BreadCrumb title="Standard Grid" innerTitle="Standard Grid" />
            <ThreeColumns />
            <FooterOne />    
        </>
    );
};

export default PortfolioThreeColumns;